import React, {useEffect} from 'react';
import {useAppDispatch} from "../../hooks/redux";
import {appSlice} from "../../store/reducers/AppSlice";
import {TransactionType} from "../../model/TransactionType";

const IncomeTransactionsPage = () => {
    const dispatch = useAppDispatch();
    const {setTitle, setTrType} = appSlice.actions;

    useEffect(() => {
        dispatch(setTitle('Income Transactions'));
        dispatch(setTrType(TransactionType.Income));
    });

    return (
        <div>

        </div>
    );
};

export default IncomeTransactionsPage;